<div
  class="platform-requests-widget-container"
  [class.loading-elements]="loading"
>
  <header class="head-wrapper">
    <div class="widget-head flex-row-centered">
      @if (loading) {
        <div class="skeleton skeleton-icon"></div>
      } @else {
        <div class="icon-wrapper flex-centered" aria-hidden="true">
          <markant-icon
            class="icon-request-widget"
            [icon]="icon"
            aria-label="Request Icon"
          ></markant-icon>
        </div>
      }
      @if (loading) {
        <div class="skeleton skeleton-title"></div>
      } @else {
        <h5 class="widget-title">{{ title }}</h5>
      }
    </div>
    @if (loading) {
      <div class="skeleton skeleton-description"></div>
      <div class="skeleton skeleton-description"></div>
    } @else {
      <p class="widget-description">{{ description }}</p>
    }
  </header>

  <section class="widget-body flex-col-centered">
    <div class="widget-content-first-section">
      @if (loading) {
        <div class="skeleton skeleton-square"></div>
      } @else {
        @if (openRequests) {
          <article class="info-square-widget">
            <h2 class="info-value-widget" aria-label="Open Requests">
              {{ openRequests.count }}
            </h2>
            <markant-chip
              class="fix-chip-label-position"
              [label]="openRequests.label"
              colorScheme="secondary"
            ></markant-chip>
          </article>
        }
      }
      @if (loading) {
        <div class="skeleton skeleton-square"></div>
      } @else {
        @if (inProgressRequests) {
          <article class="info-square-widget">
            <h2 class="info-value-widget" aria-label="In Progress Requests">
              {{ inProgressRequests.count }}
            </h2>
            <markant-chip
              class="fix-chip-label-position"
              [label]="inProgressRequests.label"
              colorScheme="warning"
            ></markant-chip>
          </article>
        }
      }
    </div>
    @if (openUpgrade !== 0 || inProgressUpgrade !== 0 || loading) {
      <div class="widget-content-second-section flex-centered">
        @if (loading) {
          <p class="skeleton skeleton-label"></p>
        } @else {
          <p class="label-second-section">{{ secondSectionLabel }}</p>
        }

        <div class="data-second-section">
          @if (loading) {
            <p class="skeleton skeleton-label"></p>
          } @else {
            <div class="info-data-second-section flex-centered">
              <p aria-label="Open Upgrade Requests">{{ openUpgrade || 0 }}</p>
              <div
                [id]="'openUpgrade-' + title"
                class="info-data-dot-secondary-section"
                aria-hidden="true"
              ></div>
              <markant-tooltip
                [for]="'openUpgrade-' + title"
                [label]="openUpgradeTooltip"
                placement="top"
                trigger="mouseenter focus"
                color-scheme="dark"
              ></markant-tooltip>
            </div>

            <div class="info-data-second-section flex-centered">
              <p aria-label="In Progress Upgrade Requests">
                {{ inProgressUpgrade || 0 }}
              </p>

              <div
                [id]="'inProgressUpgrade-' + title"
                class="info-data-dot-warning-section"
                aria-hidden="true"
              ></div>
              <markant-tooltip
                [for]="'inProgressUpgrade-' + title"
                [label]="inProgressUpgradeTooltip"
                placement="top"
                trigger="mouseenter focus"
                color-scheme="dark"
              ></markant-tooltip>
            </div>
          }
        </div>
      </div>
    }
  </section>
</div>
